import moment from 'moment';

import { OrganizationSchedule } from '../../../utils/classes';

export type ScheduleCalendarMarkedDates = Record<string, { activeCount: number; totalCount: number }>;

export function getScheduleCalendarIndicatorRange(
  organizationSchedule: OrganizationSchedule | null | undefined,
  viewedDate: moment.MomentInput
): { endDate: string; startDate: string } {
  const currentDate = moment(viewedDate).startOf('day');
  const periodUnit = organizationSchedule?.periodUnit;
  const periodStart = organizationSchedule?.periodStart ?? 1;

  if (!periodUnit) {
    return {
      startDate: currentDate.clone().startOf('month').format('YYYY-MM-DD'),
      endDate: currentDate.clone().endOf('month').format('YYYY-MM-DD')
    };
  }

  if (periodUnit === 'week') {
    const dayOfWeek = currentDate.day();
    const daysToSubtract = dayOfWeek - periodStart < 0 ? 7 - periodStart + dayOfWeek : periodStart;
    const daysToAdd = dayOfWeek - periodStart < 0 ? 7 - periodStart + dayOfWeek : periodStart + 6;

    return {
      startDate: currentDate.clone().subtract(daysToSubtract, 'days').format('YYYY-MM-DD'),
      endDate: currentDate.clone().add(daysToAdd, 'days').format('YYYY-MM-DD')
    };
  }

  if (periodUnit === 'month') {
    const dayOfMonth = currentDate.date();
    const daysToSubtract = dayOfMonth - periodStart < 0 ? 30 - periodStart + dayOfMonth : dayOfMonth - periodStart;
    const daysToAdd = dayOfMonth - periodStart < 0 ? Math.abs(periodStart - dayOfMonth) : 30 - dayOfMonth + periodStart;

    return {
      startDate: currentDate.clone().subtract(daysToSubtract, 'days').format('YYYY-MM-DD'),
      endDate: currentDate.clone().add(daysToAdd, 'days').format('YYYY-MM-DD')
    };
  }

  return {
    startDate: currentDate.clone().startOf('month').format('YYYY-MM-DD'),
    endDate: currentDate.clone().endOf('month').format('YYYY-MM-DD')
  };
}

export function mapScheduleIndicatorToMarkedDates(
  indicators: Record<string, boolean> | null | undefined
): ScheduleCalendarMarkedDates {
  return Object.entries(indicators ?? {}).reduce<ScheduleCalendarMarkedDates>((acc, [date, hasActiveSchedule]) => {
    if (!hasActiveSchedule) {
      return acc;
    }

    acc[date] = {
      activeCount: 1,
      totalCount: 1
    };

    return acc;
  }, {});
}
